export const modalWindowConstants = {
    OPEN_MODAL_WINDOW: 'modalwindow.OPEN_MODAL_WINDOW',
    CLOSE_MODAL_WINDOW: 'modalwindow.CLOSE_MODAL_WINDOW',
    SET_FILE_MIMETYPE: 'modalwindow.SET_FILE_MIMETYPE',
    SET_FILE_ID: 'modalwindow.SET_FILE_ID',
    SET_FILE_URL: 'modalwindow.SET_FILE_URL',
    SET_FILE_BLOB: 'modalwindow.SET_FILE_BLOB',
} as const;
